import { Link } from "react-router-dom";
import Masonry from "react-masonry-css";
import { OptimizedBackgroundImage } from "./OptimizedBackgroundImage";
import { categories } from "../content";

const GalleryPreview = () => {
  // Masonry breakpoints
  const breakpointColumnsObj = {
    default: 4,
    1100: 3,
    700: 2,
    500: 1,
  };

  return (
    <section id="gallery-preview" className="section bg-linen">
      <div className="container">
        <h2 className="mb-6 text-3xl font-bold text-center font-serif header-color md:text-4xl">
          Наши фотозоны
        </h2>

        <p className="max-w-2xl mx-auto mb-12 text-center text-gray-700">
          Выберите любую из наших тематических локаций для идеальной фотосессии.
          Нажмите на категорию для просмотра всех фотографий.
        </p>

        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="masonry-grid"
          columnClassName="masonry-grid_column"
        >
          {categories.map((category) => (
            <div key={category.id} className="masonry-item mb-4">
              <Link
                to={`/gallery/${category.id}`}
                className="block overflow-hidden group rounded-xl shadow-lg transition-shadow duration-300 hover:shadow-xl"
              >
                <div className="category-card">
                  <div className="category-card-images">
                    <OptimizedBackgroundImage
                      className="category-card-image"
                      src={category.preview}
                    />
                    <div className="category-card-title">
                      <h3>{category.title}</h3>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </Masonry>
      </div>
    </section>
  );
};

export default GalleryPreview;
